import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'
 
import StepinList from './StepinList.vue' 

declareVconsoleComponent('stepinList', StepinList, 'stepin:list');